import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    margin-top: 1rem;

    .ant-select {
        color: #000;
        width: 140px;
    }
    .ant-select-selection  {
        border-radius: 0px;
        border: 2px solid #3a4fff;
    }
    .ant-input-number {
        border-radius: 0px;
        border-width: 2px 2px 2px 0px;
        border-color: #3A4FFF;
        width: 145px;
    }
    .ant-input {
        border-radius: 0px;
        /* border-width: 2px 2px 2px 0px;
        border-color: 1px solid #A8A8B1; */
        width: 145px;
    }
    .filter-btn {
        width: 140px;
    }
    .ant-calendar-picker-icon {
        display: none;
    }
    .ant-calendar-picker-input {
        width: 220px;
        border-width: 2px 2px 2px 0px;
        border-color: #0000FF;
    } 
`;